import React from "react";
import {
  Button,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";

export default function BuchungenTable({ buchungen, handleDeleteBuchung }) {
  const [show, setShow] = React.useState(false);

  const handleShow = () => {
    setShow(!show);
  };

  const formatCurrency = (value) =>
    new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
    }).format(value || 0);

  const formatDate = (value) => {
    if (!value) return "—";
    const parsed = dayjs(value);
    return parsed.isValid()
      ? parsed.format("DD.MM.YYYY")
      : new Date(value).toLocaleDateString("de-DE");
  };

  const formatDateTime = (value) => {
    if (!value) return "—";
    const parsed = dayjs(value);
    return parsed.isValid()
      ? parsed.format("DD.MM.YYYY HH:mm")
      : new Date(value).toLocaleString("de-DE");
  };

  const typeLabels = {
    contribution: "Beiträge",
    testing: "Prüfungen",
    fee: "Gebühren",
    other: "Sonstiges",
  };

  return (
    <div>
      <Button variant="contained" color="primary" onClick={handleShow}>
        Buchungen {show ? "einklappen" : "anzeigen"}
      </Button>
      {show && (
        <div>
          <div style={{ margin: 15 }}>
            <Typography variant="h6">
              VORSICHT! <br />
              Gelöschte Buchungen können nicht wiederhergestellt werden!
            </Typography>
          </div>
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Datum</TableCell>
                  <TableCell>Typ</TableCell>
                  <TableCell>Buchungsmonat</TableCell>
                  <TableCell align="right">Mitglieder</TableCell>
                  <TableCell align="right">Summe</TableCell>
                  <TableCell align="center">Vorgänge</TableCell>
                  <TableCell>Verwendungszweck</TableCell>
                  <TableCell align="right">Erstellt am</TableCell>
                  <TableCell align="right">Löschen</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {buchungen.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={9}>
                      <Typography variant="body2" color="text.secondary">
                        Keine Buchungen vorhanden.
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  buchungen.map((buchung) => (
                    <TableRow key={buchung._id || buchung.buchungId}>
                      <TableCell component="th" scope="row">
                        {formatDate(buchung.bookingDate || buchung.createdAt)}
                      </TableCell>
                      <TableCell>
                        <Chip
                          size="small"
                          label={
                            typeLabels[buchung.bookingType] || "Sonstiges"
                          }
                          color={
                            buchung.bookingType === "contribution"
                              ? "primary"
                              : buchung.bookingType === "testing"
                              ? "info"
                              : buchung.bookingType === "fee"
                              ? "warning"
                              : "default"
                          }
                        />
                      </TableCell>
                      <TableCell>{buchung.bookMonth || "—"}</TableCell>
                      <TableCell align="right">
                        {buchung.membersCount ?? buchung.activeMembers ?? 0}
                      </TableCell>
                      <TableCell align="right">
                        {formatCurrency(buchung.totalSum)}
                      </TableCell>
                      <TableCell align="center">
                        {buchung.transactionsCount ?? "—"}
                      </TableCell>
                      <TableCell>{buchung.referenceText || "—"}</TableCell>
                      <TableCell align="right">
                        {formatDateTime(buchung.createdAt)}
                      </TableCell>
                      <TableCell align="right">
                        <Button
                          variant="contained"
                          color="error"
                          onClick={() => handleDeleteBuchung(buchung)}
                        >
                          Löschen
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )}
    </div>
  );
}
